import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { motion } from 'framer-motion';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../redux/userSlice';
import Navbar from '../Navbar/Navbar';
import './RegistrationAndLogin.css';


const RegistrationAndLogin = () => {
  const { user, isAuthenticated } = useSelector((state) => state.user);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const ENV_MODE = process.env.REACT_APP_ENV_MODE;
  const CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
  const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET; 
  const FRONTEND_URL = process.env.REACT_APP_API_URL_FRONTEND;
  const redirectUri = FRONTEND_URL+'/linkedin';
  const state = process.env.REACT_APP_STATE;
  const scope = 'r_liteprofile r_emailaddress openid';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formType, setFormType] = useState('register');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [userData, setUserData] = useState(null);
  const isLargeScreen = useMediaQuery('(min-width: 1024px)');

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    confirm_password: '',
    role: 'B2B',
    phone: '',
    message: '',
    country: 'Germany',
    gender: '',
    company_name: ''
  });

  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
  
    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) setMatches(media.matches);
      const listener = () => setMatches(media.matches);
      media.addEventListener('change', listener);
      return () => media.removeEventListener('change', listener);
    }, [query, matches]);
  
    return matches;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const base64Data = params.get("data");

  if (base64Data) {
    try {
      // Use atob for base64 decoding in browser
      const jsonString = atob(base64Data);
      const linkedInResponse = JSON.parse(jsonString);

      // console.log("LinkedIn response:", linkedInResponse);

      dispatch(setUser({ user: linkedInResponse.user, token: linkedInResponse.token }));

      // Redirect to dashboard or wherever
      navigate("/dashboard/dashboard");
    } catch (err) {
      console.error("Error decoding LinkedIn data", err);
    }
  }
}, [dispatch, navigate]);

const handleLinkedInLogin = async () => {
  // Optionally show a loading spinner here, e.g. setLoading(true);

  try {
    // Wake up the backend (ping endpoint)
    await fetch(`${API_URL}/public/api/v0/ping`); // Make sure this matches your backend route!

    // After ping, construct LinkedIn URL as before
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: CLIENT_ID,
      redirect_uri: `${API_URL}/public/api/v0/linkedIn/callback`, // This should be EXACTLY what you have in LinkedIn developer portal!
      scope: 'openid email profile',
    });

    // Redirect to LinkedIn
    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params}`;
  } catch (err) {
    alert('Could not reach server. Please try again in a few seconds.');
    // Optionally hide loading spinner, e.g. setLoading(false);
  }
};





  const resetForm = () => {
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      confirm_password: '',
      role: 'B2B',
      phone: '',
      message: '',
      country: 'Germany',
      gender: '',
      company_name: ''
    });
    setErrors({});
  };

  const validate = () => {
    const errs = {};
    if (formType === 'register') {
      if (!formData.first_name || /\d/.test(formData.first_name)) errs.first_name = 'First name is required and must not contain numbers.';
      if (!formData.last_name || /\d/.test(formData.last_name)) errs.last_name = 'Last name is required and must not contain numbers.';
      if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) errs.email = 'Valid email is required.';
      if (!formData.password || formData.password.length < 6) errs.password = 'Password must be at least 6 characters.';
      if (formData.password !== formData.confirm_password) errs.confirm_password = 'Passwords do not match.';
      if (!formData.country) errs.country = 'Country is required.';
      // if (!formData.gender) errs.gender = 'Gender is required.';
      if (formData.role === 'B2B' && !formData.company_name) errs.company_name = 'Company name is required for B2B.';
    } else {
      if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) errs.email = 'Valid email is required.';
      if (!formData.password) errs.password = 'Password is required.';
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const endpoint = formType === 'register' ? '/public/api/v0/register' : '/public/api/v0/login';
    const payload = formType === 'register'
      ? { ...formData, confirm_password: undefined }
      : { email: formData.email, password: formData.password };

    try {
      const res = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      setLoading(false);

      if (res.ok) {
        if (formType === 'register') {
          setSuccessMessage(result.message || 'Registered successfully!');
          resetForm();
          setTimeout(() => setSuccessMessage(''), 4000);
        } else {
          dispatch(setUser({ user: result.user, token: result.token }));
          navigate('/dashboard/dashboard');
        }
      } else {
        setErrors({ form: result.msg || `${formType} failed.` });
      }
    } catch (err) {
      console.error(`${formType} error:`, err);
      setLoading(false);
    }
  };

  return (
    <div className="register-login-wrapper">
      {isLargeScreen && <Navbar className="contact-navbar" />}
      {/* <Navbar className={'contact-navbar'} /> */}
      <Container fluid className="sign_in_form_row">
        <Row className="min-vh-100">
          <Col md={12} className="left-column p-0">
            <div className="image-overlay">
              <img src="/login.jpg" alt="Background" className="background-image" />
              <div className="overlay-text-login">
                <h2>Welcome to ZNOTEC</h2>
                <p>Empowering Freelancers, Job Seekers & Businesses</p>
                <div className="text-center mb-3">
                  <Button variant="secondary" className='linkedIn-btn' onClick={handleLinkedInLogin}>Login with LinkedIn</Button>
                </div>
              </div>
              
            </div>
          </Col>
          {/* use again  */}
          {/* <Col md={6} className="form-column d-flex align-items-center justify-content-center">
            <motion.div className="form-container sign_in_form w-100" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
             
                <div className="text-center mb-4">
                  <Button
                    id="register-btn"
                    variant={formType === 'register' ? 'primary' : 'outline-primary'}
                    className={formType === 'register' ? 'mx-2 active' : 'mx-2'}
                    onClick={() => {
                      setFormType('register');
                      resetForm();
                    }}
                  >
                    Register
                  </Button>
                  <Button
                    id="login-btn"
                    variant={formType === 'login' ? 'primary' : 'outline-primary'}
                    className={formType === 'login' ? 'mx-2 active' : 'mx-2'}
                    onClick={() => {
                      setFormType('login');
                      resetForm();
                    }}
                  >
                    Login
                  </Button>
                </div>


              <div className="text-center mb-3">
                <Button variant="secondary" className='linkedIn-btn' onClick={handleLinkedInLogin}>Login with LinkedIn</Button>
              </div>
              {successMessage && <Alert variant="success">{successMessage}</Alert>}
              {errors.form && <Alert variant="danger">{errors.form}</Alert>}



              <div className="d-flex align-items-center my-3">
                <div className="flex-grow-1 border-top"></div>
                <span className="mx-3 text-muted">or</span>
                <div className="flex-grow-1 border-top"></div>
              </div>
              <Form onSubmit={handleSubmit}>
                {formType === 'register' && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>First Name</Form.Label>
                          <Form.Control name="first_name" value={formData.first_name} onChange={handleChange} isInvalid={!!errors.first_name} />
                          <Form.Control.Feedback type="invalid">{errors.first_name}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-2">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control name="last_name" value={formData.last_name} onChange={handleChange} isInvalid={!!errors.last_name} />
                          <Form.Control.Feedback type="invalid">{errors.last_name}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-2">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} isInvalid={!!errors.email} />
                      <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>
                    

                    <Form.Group className="mb-2 position-relative">
                      <Form.Label>Password</Form.Label>
                      <div className="password-wrapper">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? (
                            <i className="bi bi-eye-slash-fill"></i>
                          ) : (
                            <i className="bi bi-eye-fill"></i>
                          )}
                        </span>
                        <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-2 position-relative">
                      <Form.Label>Confirm Password</Form.Label>
                      <div className="password-wrapper">
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirm_password"
                          value={formData.confirm_password}
                          onChange={handleChange}
                          isInvalid={!!errors.confirm_password}
                        />
                        <span className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? (
                            <i className="bi bi-eye-slash-fill"></i>
                          ) : (
                            <i className="bi bi-eye-fill"></i>
                          )}
                        </span>
                        <Form.Control.Feedback type="invalid">{errors.confirm_password}</Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    
                    <Form.Group className="mb-2">
                      <Form.Label>Role</Form.Label>
                      <Form.Select name="role" value={formData.role} onChange={handleChange}>
                        <option value="B2B">B2B</option>
                        <option value="Freelancer">Freelancer</option>
                        <option value="JobSeeker">JobSeeker</option>
                      </Form.Select>
                    </Form.Group>
                    {formData.role === 'B2B' && (
                      <Form.Group className="mb-2">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control name="company_name" value={formData.company_name} onChange={handleChange} isInvalid={!!errors.company_name} />
                        <Form.Control.Feedback type="invalid">{errors.company_name}</Form.Control.Feedback>
                      </Form.Group>
                    )}
                    <Form.Group className="mb-2">
                      <Form.Label>Phone Number (Optional)</Form.Label>
                      <Form.Control name="phone" value={formData.phone} onChange={handleChange} />
                    </Form.Group>
                    
                    <Form.Group className="mb-2">
                      <Form.Label>Country</Form.Label>
                      <Form.Control name="country" value={formData.country} onChange={handleChange} isInvalid={!!errors.country} />
                      <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                    </Form.Group>
                    
                  </>
                )}
                {formType === 'login' && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
                    </Form.Group>
                   

                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Password</Form.Label>
                      <div className="password-wrapper">
                        <Form.Control
                          type={showLoginPassword ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span className="password-toggle" onClick={() => setShowLoginPassword(!showLoginPassword)}>
                          {showLoginPassword ? (
                            <i className="bi bi-eye-slash-fill"></i>
                          ) : (
                            <i className="bi bi-eye-fill"></i>
                          )}
                        </span>
                      </div>
                    </Form.Group>

                  </>
                )}
                <div className="text-center mt-3">
                  <Button type="submit" variant="primary" size="lg" disabled={loading}>
                    {loading ? <><Spinner as="span" animation="border" size="sm" role="status" className="me-2" />Loading...</> : (formType === 'register' ? 'Register' : 'Login')}
                  </Button>
                </div>
              </Form>
            </motion.div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default RegistrationAndLogin;
